export const GET_ALL_CUSTOMDATATYPE = "GET_ALL_CUSTOMDATATYPE";
